module.exports = __webpack_public_path__ + "static/img/wind-circle.f40ca3b9.png";